"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarImager = void 0;
const loader_1 = require("../../../engine/loader");
const application_provider_1 = require("../../pixi/application.provider");
const injets_1 = require("injets");
const AvatarStructure_1 = require("./AvatarStructure");
const figure_1 = require("./util/figure");
let AvatarImager = class AvatarImager {
    constructor(loader, appProvider) {
        this.loader = loader;
        this.app = appProvider.app;
    }
    getData(name) {
        return this.loader.resources[name].json;
    }
    get figuremap() {
        return this.getData('figuremap');
    }
    get figuredata() {
        return this.getData('figuredata');
    }
    get partsets() {
        return this.getData('partsets');
    }
    get avatarActions() {
        return this.getData('avatarActions');
    }
    get geometry() {
        return this.getData('geometry');
    }
    get animations() {
        return this.getData('animations');
    }
    get effectmap() {
        return this.getData('effectmap');
    }
    get actionTypeToAnimationName() {
        if (this._actionTypeToAnimationName) {
            return this._actionTypeToAnimationName;
        }
        return this._actionTypeToAnimationName = Object.entries(this.avatarActions)
            .reduce((acc, [name, { state }]) => (Object.assign(Object.assign({}, acc), { [state]: name })), {});
    }
    loadDependencies(setTypes) {
        return __awaiter(this, void 0, void 0, function* () {
            const dependencies = setTypes.flatMap(({ set }) => {
                const setDependecies = set.parts.map(part => {
                    const lib = figure_1.HumanFigure.getLib(this.figuremap, part.type, part.id);
                    return lib && `${lib}/${lib}.json`;
                });
                return Array.from(new Set(setDependecies));
            }).filter(e => e);
            yield this.loader.add(dependencies).wait();
        });
    }
    createFigure(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const setTypes = Object.entries(options.figure)
                .map(([typeName, partOptions]) => {
                const settype = this.figuredata.settype[typeName];
                const palette = this.figuredata.palette[settype.paletteid];
                const colors = partOptions.colors.map(colorId => Number('0x' + palette[colorId].color));
                return {
                    set: this.figuredata.settype[typeName].set[+partOptions.id],
                    settype,
                    colors,
                    typeName
                };
            });
            yield this.loadDependencies(setTypes);
            const actions = this.getActions(options);
            const structure = new AvatarStructure_1.AvatarStructure(this, actions).build(setTypes, options);
            const container = structure.createContainer(options);
            return {
                container,
                structure
            };
        });
    }
    getActions(props) {
        let actions = Object.keys(props.actions)
            .map(a => this.avatarActions[this.actionTypeToAnimationName[a]])
            .filter(a => a)
            .sort((a, b) => b.precedence - a.precedence);
        for (const action of actions) {
            const prevents = new Set((action.prevents || '').split(','));
            if (prevents.size > 0) {
                actions = actions.filter(a => {
                    if (a.state === 'fx') {
                        return !prevents.has([a.state, props.actions.fx].join('.'));
                    }
                    return !prevents.has(a.state);
                });
            }
        }
        return actions;
    }
};
AvatarImager = __decorate([
    injets_1.Provider(),
    __metadata("design:paramtypes", [loader_1.Loader, application_provider_1.ApplicationProvider])
], AvatarImager);
exports.AvatarImager = AvatarImager;
